<template>
  <a-modal :title="`【${user.name}】的碎片`"
           :width="800"
           :open="modal"
           @cancel="cancelCk">
    <a-space class="nav-no-title">
      <div>当前碎片
        <a-tag :bordered="false" color="green">{{ current }}</a-tag>
      </div>
      <a-button size="small" type="primary" @click="addCk">调整碎片</a-button>
    </a-space>

    <a-table size="small"
             :columns="columns"
             :dataSource="source"
             :pagination="pagination"
             :loading="loading"
             :onChange="handlePage">
      <template v-slot:bodyCell="{ column, record }">
        <template v-if="column.dataIndex === 'num'">
          <a-tag :bordered="false" :color="record.num > 0 ? 'green' : 'red'">{{ record.num }}</a-tag>
        </template>

        <template v-else-if="column.dataIndex === 'state'">
          <a-tag v-if="record.state === 1" :bordered="false">正常</a-tag>
          <a-tag v-else-if="record.state === 2" color="orange" :bordered="false">已发放</a-tag>
          <a-tag v-else color="red" :bordered="false">禁用</a-tag>
        </template>

        <template v-else>
          {{ record[column.dataIndex] }}
        </template>
      </template>
    </a-table>

    <template #footer></template>
  </a-modal>

  <add-shard-modal ref="addShard" @refresh="query"/>
</template>

<script setup>
import {ref} from 'vue'
import axios from '@/axios'

import AddShardModal from '@/views/user/AddShard.vue'

const current = ref(0)

const source = ref([])

const user = ref({})

const modal = ref(false)
const loading = ref(false)

const addShard = ref(null)

const pagination = ref({
  showSizeChanger: true,
  defaultCurrent: 1,
  defaultPageSize: 10,
  current: 1,
  pageSize: 10,
  total: 0,
  onShowSizeChange: (current, size) => {
    pagination.value.current = 1
    pagination.value.pageSize = size
    query()
  }
})

const columns = [
  {
    key: 'id',
    title: 'ID',
    dataIndex: 'id',
  }, {
    key: 'num',
    title: '碎片',
    dataIndex: 'num',
  }, {
    key: 'source',
    title: '来源',
    dataIndex: 'source',
  }, {
    key: 'state',
    title: '状态',
    dataIndex: 'state',
  }, {
    key: 'createTime',
    title: '时间',
    dataIndex: 'createTime',
  }
]

function query() {
  loading.value = true

  axios.get(`/user/${user.value.id}/shard`, {
    params: {
      page: pagination.value.current,
      size: pagination.value.pageSize,
    }
  }).then((res) => {
    loading.value = false

    if (res.code === 1) {
      pagination.value.current = res.data.page
      pagination.value.total = res.data.total
      source.value = res.data.data
      current.value = res.data.current
    }

    modal.value = true
  })
}

function handlePage(param) {
  pagination.value.current = param.current
  pagination.value.pageSize = param.pageSize
  query()
}

function openCk(record) {
  user.value = record
  pagination.value.current = 1
  query()
}

function addCk() {
  addShard.value.openCk(user.value.id)
}

function cancelCk() {
  modal.value = false
  loading.value = false
}

defineExpose({openCk})
</script>